import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import App from './App.vue';
import { router } from './router';
import { useThemeStore } from './stores/theme';
import './assets/app.css';

const app = createApp(App);
app.use(createPinia());
useThemeStore();
app.use(router);
app.mount('#app');
